import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "auth-layout" }
const _hoisted_2 = { class: "auth-brand" }
const _hoisted_3 = { class: "auth-brand-content" }
const _hoisted_4 = { class: "auth-tagline" }
const _hoisted_5 = { class: "auth-tagline auth-tagline-strong" }
const _hoisted_6 = { class: "auth-form" }
const _hoisted_7 = { class: "auth-form-content" }
const _hoisted_8 = { class: "auth-title" }
const _hoisted_9 = {
  key: 0,
  class: "auth-subtitle"
}
const _hoisted_10 = { class: "auth-social" }
const _hoisted_11 = { class: "auth-or" }
const _hoisted_12 = {
  key: 2,
  class: "auth-foot"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("h1", { class: "auth-logo" }, "lunedi", -1)),
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$tt('auth-tagline')), 1),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$tt('auth-tagline-detail')), 1)
      ])
    ]),
    _createElementVNode("section", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("h2", _hoisted_8, _toDisplayString(_ctx.title), 1),
        (_ctx.subtitle)
          ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.subtitle), 1))
          : _createCommentVNode("", true),
        (_ctx.$slots.social)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_10, [
                _renderSlot(_ctx.$slots, "social", {}, undefined, true)
              ]),
              _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$tt('auth.or')), 1)
            ], 64))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "default", {}, undefined, true),
        (_ctx.$slots.foot)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _renderSlot(_ctx.$slots, "foot", {}, undefined, true)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}